class Elementor_Text_Carousel{
    static instance;

    static getInstance() {
        if (!Elementor_Text_Carousel.instance) {
            Elementor_Text_Carousel.instance = new Elementor_Text_Carousel();
        }
        return Elementor_Text_Carousel.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-text_carousel.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
                setTimeout(() => {
                    $carousel.trigger('refresh.owl.carousel');
                }, 100);
            }
        } );
    }
}


Elementor_Text_Carousel.getInstance();